import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
import clsx from 'clsx';
import {
  Button,
  Card,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography
} from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import Header from '../headers/Header';
import Footer from '../footer/Footer';
import authService from '../../services/auth.service';

const useStyles = makeStyles(() => ({
  root: {
    margin: '20px 20px',
    padding: '20px 20px',
  },
  title: {
    color: 'var(--gmi-color)',
    textAlign: 'center'
  },
  button: {
    background: 'var(--gmi-color)',
    color: 'white'
  },
  container: {
    maxHeight: 440
  }
}));

const columns = [
  { id: "name", label: "Logo", minWidth: 170, align: "center" },
  { id: "name", label: "Name", minWidth: 170, align: "center" },
  { id: "total workshops", label: "Total Workshops", minWidth: 170, align: "center" },
  { id: "total users", label: "Total Users", minWidth: 170, align: "center" },
  { id: "total consoles", label: "Total Consoles", minWidth: 170, align: "center" }
]

const AdminDashboard = ({ className, ...rest }) => {
  const [customers, setCustomers] = useState ([]);
  // const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const classes = useStyles();
  const user = authService.getCurrentUser();
  console.log("aaaaaaaaaaaaaaaa"+user)
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    const getCustomers = async () => {
      const result = await axios.get('http://cloud.gmi-aero.com:5000/customers');
      setCustomers(result.data);
    };
    getCustomers();
  }, []);

  return (
    <Fragment>
      <Header type={"admin"} />
      <Card
        className={clsx(classes.root, className)}
        elevation={2}
        {...rest}
      >
        <Typography
          className={classes.title}
          gutterBottom
          variant="h4">
          CUSTOMERS
        </Typography>

        <TextField 
        className={classes.input}
        id="outlined-search" 
        label="Search" 
        type="search" 
        variant="outlined" 
        // onChange={(event) => {
        //   setSearchTerm(event.target.value)
        // }}
        />

        <Button
        className={classes.button}
        >
          Create a new customers
        </Button>

        <Grid>
          <Paper className={classes.root}>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {customers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map(customer => {
                      return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={customer.code}>
                          {columns.map((column) => {
                            const value = customer[column.id];
                             
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  {column.format && typeof value === "number"
                                  ? column.format(value)
                                  : value}
                                  {/* <div>
                                    <td>{customer.cust_main_name}</td>
                                  </div> */}
                                </TableCell>
                              );
                          })}
                        </TableRow>
                      );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={customers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Paper>
        </Grid>
      </Card>



    <Footer type="main"/>
    </Fragment>
  )
};

export default AdminDashboard;